module.exports = ['$scope', '$q', '$location', 'WizardState', 'Survey', 'sriClient', 'Utils', 'Organisations',
  async function ($scope, $q, $location, WizardState, Survey, sriClient, Utils, Organisations) { //eslint-disable-line


    $scope.$emit('wellbe_wizard_visibility', { visible: false });
    $scope.$emit('wellbe_header_logoVisibility', { visible: true });

    Survey.clear();

    const allOus = await Organisations.getRelevantOusForUser();
    $scope.schools = Object.values(allOus).sort((s1, s2) => {
      const sortOrderDiff = (s1.sortOrder || 0) - (s2.sortOrder || 0);
      return sortOrderDiff || s1.name.localeCompare(s2.name);
    });

    const userNumBoardings = $scope.schools.filter(school => school.ouType === 'BOARDING').length;
    const userNumLeersteuncentra = $scope.schools.filter(school => school.type === 'LEERSTEUNCENTRUM').length;
    const userNumSchools = $scope.schools.filter(school => school.ouType === 'SCHOOLENTITY').length;
    // const userNumGoverningInstitutions = $scope.schools.filter(school => school.type === 'GOVERNINGINSTITUTION').length;
    const userNumCVOs = $scope.schools.filter(school => school.type === 'CVO').length;

    if(userNumSchools === $scope.schools.length) {
      $scope.institutionText = ['Welke school', 'school', 'de school'];
    } else if(userNumBoardings === $scope.schools.length) {
      $scope.institutionText = ['Welk internaat', 'internaat', 'het internaat'];
    } else if(userNumLeersteuncentra === $scope.schools.length) { 
      $scope.institutionText = ['Welk leersteuncentrum', 'leersteuncentrum', 'het leersteuncentrum'];
    } else if(userNumCVOs === $scope.schools.length) {
      $scope.institutionText = ['Welke centra', 'centrum', 'het centrum'];
    } else {
      $scope.institutionText = ['Welke school of instelling', 'school of een instelling', 'de school of de instelling'];
    }

    $scope.onChooseSchool = function (school) {
      console.log('on choose school:', school.href);

      Survey.setSchool(school);

      // physical location should be chosen if more than 1 for selected school entity (#15577)
      if (school.locations && school.locations.length > 1) {
        $location.path('/locations');
      } else {
        if (school.locations && school.locations.length === 1) {
          Survey.setPhysicalLocation(school.locations[0]);
        }
        
        $location.path('/intake');
      }
    };
  }];
